import React from "react";
import { BookOpen, ArrowRight, HelpCircle } from "lucide-react";
import { FLUSSI, FAQ } from "../config/guide";

export default function ComeFunziona() {
  return (
    <div className="space-y-8 pb-16" data-testid="come-funziona-page">
      <div>
        <h1 className="text-2xl font-head font-bold flex items-center gap-2"><BookOpen size={24} className="text-primary" /> Come funziona</h1>
        <p className="text-sm text-muted-foreground">Guida ai flussi dell'area amministrativa: dai dati inseriti fino alla Dashboard di gestione.</p>
      </div>

      <div className="grid gap-5 lg:grid-cols-2" data-testid="cf-flussi">
        {FLUSSI.map((f) => (
          <div key={f.id} className="gr-card p-5 border-t-4" style={{ borderColor: f.color }} data-testid={`cf-flusso-${f.id}`}>
            <h2 className="font-head font-bold text-lg mb-4" style={{ color: f.color }}>{f.title}</h2>
            <ol className="space-y-3">
              {f.steps.map((s, i) => (
                <li key={i} className="flex gap-3 items-start">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold text-white" style={{ background: f.color }}>{i + 1}</span>
                  <span className="text-sm leading-relaxed">{s}</span>
                  {i < f.steps.length - 1 && null}
                </li>
              ))}
            </ol>
            {f.nota && (
              <div className="mt-4 rounded-lg bg-secondary/60 px-3 py-2 text-xs text-muted-foreground flex gap-2">
                <ArrowRight size={14} className="mt-0.5 shrink-0" style={{ color: f.color }} /> {f.nota}
              </div>
            )}
          </div>
        ))}
      </div>

      <div>
        <h2 className="font-head font-bold text-lg mb-3 flex items-center gap-2"><HelpCircle size={20} className="text-primary" /> Domande frequenti</h2>
        <div className="space-y-3" data-testid="cf-faq">
          {FAQ.map((item, i) => (
            <div key={i} className="gr-card p-4" data-testid={`cf-faq-${i}`}>
              <div className="font-semibold text-sm">{item.q}</div>
              <div className="text-sm text-muted-foreground mt-1 leading-relaxed">{item.a}</div>
            </div>
          ))}
        </div>
      </div>

      <p className="text-xs text-muted-foreground">
        In ogni pagina trovi il pulsante <span className="font-semibold text-primary">?</span> in alto a destra con i consigli rapidi specifici di quella schermata.
      </p>
    </div>
  );
}
